export default "__VITE_ASSET__BVeOr3K8__"